import { __makeTemplateObject } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Heading } from '../heading/Heading.js';
import { Text } from '../text/Text.js';

var Container = /*#__PURE__*/styled(Box).withConfig({
  displayName: "TimeDisplay__Container",
  componentId: "sc-j0z7q-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  text-decoration: none;\n  border: 1px solid ", ";\n  border-radius: 50px;\n"], ["\n  padding: 0;\n  text-decoration: none;\n  border: 1px solid ", ";\n  border-radius: 50px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.disabled;
});
var DaysLeft = /*#__PURE__*/styled(Text).withConfig({
  displayName: "TimeDisplay__DaysLeft",
  componentId: "sc-j0z7q-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  font-size: 9px;\n  text-transform: uppercase;\n  text-align: center;\n  white-space: nowrap;\n  align-items: center;\n\n  strong {\n    font-size: 14px;\n    font-weight: 500;\n    padding: 0 3px;\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  font-size: 9px;\n  text-transform: uppercase;\n  text-align: center;\n  white-space: nowrap;\n  align-items: center;\n\n  strong {\n    font-size: 14px;\n    font-weight: 500;\n    padding: 0 3px;\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
});
var TimeLabel = /*#__PURE__*/styled(Text).withConfig({
  displayName: "TimeDisplay__TimeLabel",
  componentId: "sc-j0z7q-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n  text-transform: uppercase;\n  width: 45px;\n"], ["\n  text-align: center;\n  text-transform: uppercase;\n  width: 45px;\n"])));
var TimeValue = /*#__PURE__*/styled(Heading).withConfig({
  displayName: "TimeDisplay__TimeValue",
  componentId: "sc-j0z7q-3"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: center;\n  font-weight: 700;\n  width: 45px;\n"], ["\n  text-align: center;\n  font-weight: 700;\n  width: 45px;\n"])));
var TimeSegment = function (_a) {
  var label = _a.label,
    _b = _a.value,
    value = _b === void 0 ? 0 : _b,
    timeFontSize = _a.timeFontSize,
    spacing = _a.spacing,
    divider = _a.divider,
    countDays = _a.countDays,
    color = _a.color,
    showSecs = _a.showSecs;
  return React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    borderRight: divider ? "1px solid #d9d9d9" : "0px",
    width: countDays ? showSecs ? "25%" : "33%" : "33%"
  }, React__default.createElement(Box, {
    margin: spacing
  }, React__default.createElement(TimeValue, {
    forwardedAs: "span",
    color: color || "greenLantern",
    fontSize: timeFontSize
  }, "0".concat(value).slice(-2))), React__default.createElement(TimeLabel, {
    forwardedAs: "span",
    letterSpacing: "wide",
    fontSize: "10px"
  }, label));
};
var TimeDisplay = function (_a) {
  var days = _a.days,
    hrs = _a.hrs,
    mins = _a.mins,
    secs = _a.secs,
    height = _a.height,
    countDays = _a.countDays,
    _b = _a.countHours,
    countHours = _b === void 0 ? true : _b,
    timeFontSize = _a.timeFontSize,
    spacing = _a.spacing,
    divider = _a.divider,
    color = _a.color,
    showSecs = _a.showSecs;
  var daysLabel = days && days > 1 ? "days" : "day";
  return React__default.createElement(Container, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    height: height
  }, days && !countDays ? React__default.createElement(DaysLeft, {
    lineHeight: "none",
    letterSpacing: "wide"
  }, React__default.createElement("strong", null, days), " ", daysLabel) : React__default.createElement(React__default.Fragment, null, countDays && React__default.createElement(TimeSegment, {
    label: daysLabel,
    value: days,
    timeFontSize: timeFontSize,
    spacing: spacing,
    divider: divider,
    countDays: countDays,
    color: color,
    showSecs: showSecs
  }), countHours && React__default.createElement(TimeSegment, {
    label: "hrs",
    value: hrs,
    timeFontSize: timeFontSize,
    spacing: spacing,
    divider: divider,
    countDays: countDays,
    color: color,
    showSecs: showSecs
  }), React__default.createElement(TimeSegment, {
    label: "mins",
    value: mins,
    timeFontSize: timeFontSize,
    spacing: spacing,
    divider: showSecs && divider,
    countDays: countDays,
    color: color,
    showSecs: showSecs
  }), showSecs && React__default.createElement(TimeSegment, {
    label: "secs",
    value: secs,
    timeFontSize: timeFontSize,
    spacing: spacing,
    countDays: countDays,
    color: color,
    showSecs: showSecs
  })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { TimeDisplay };
//# sourceMappingURL=TimeDisplay.js.map
